module.exports = __webpack_public_path__ + "static/media/VideoTutorialFocused.25074f80.svg";